if (!customElements.get('article-products')) {

  class ArticleProducts extends HTMLElement {

    constructor() {
      super();

      this.productCards = this.querySelector('[data-article-product-cards]');

      /**
       * Fetch SKU Products from data-attribute
       */
      if (this.hasAttribute('data-skus')) {
        this.fetchSKUS(this.getAttribute('data-skus'));
      }
      
    }

    fetchSKUS(skus) {
        try {
            skus = JSON.parse(skus);
            if (skus.length) {
                skus = skus.map(sku => `variants.sku:${sku}\*`);
                let url;
                if(this.hasAttribute('data-locale')) {
                    url = new URL(`${window.location.origin}/${this.getAttribute('data-locale')}/search`);
                } else {
                    url = new URL(`${window.location.origin}/search`);
                }
                url.search = new URLSearchParams({ q: skus.join(' OR '), type: "product", view: `sku` }).toString();
                fetch(url).then(r => r.json()).then(r => this.parseResults(r));
            }
        } catch (error) {
            console.log(error)
        }
    }

    /**
     * 
     * Interprets the result of the search fetch and replaces all virtual skeleton loading slides of swiper
     * 
     * @param {Object} r 
     */
     parseResults(r) {
      if (r && r.results_count > 0) {
        let html = '';
        r.results.forEach(product => {
            html += new DOMParser().parseFromString(product.cardHtml, 'text/html').querySelector('body').innerHTML;
        });
        this.productCards.innerHTML = html;
      } else {
        if (this.parentNode.nextElementSibling.tagName == 'BR') {
          this.parentNode.nextElementSibling.remove();
        }
        if (this.parentNode.nextElementSibling.tagName == 'BR') {
          this.parentNode.nextElementSibling.remove();
        }
        if (this.parentNode.nextElementSibling.tagName == 'BR') {
          this.parentNode.nextElementSibling.remove();
        }
        if (this.parentNode.nextElementSibling.tagName == 'BR') {
          this.parentNode.nextElementSibling.remove();
        }
        this.parentNode.remove();
      }
    }

  }

  customElements.define('article-products', ArticleProducts);

}


